<template>
  <div>
    <!-- Header -->
    <div class="header py-5 py-lg-7 pt-lg-7">
      <b-container class="container">
        <div v-if="false" class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Criar uma conta</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>

      <div
        v-if="false"
        class="separator separator-bottom separator-skew zindex-100"
      >
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>

    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center bg-white pt-5">
        <b-col lg="6" md="6" sm="6">
          <b-card
            v-if="place_public_data"
            class="bg-transparent text-center"
            style="-webkit-box-shadow: none; box-shadow: none"
          >
            <b-card-body>
              <img
                v-if="placeLogoUrl"
                :src="placeLogoUrl"
                style="
                  max-width: 250px;
                  height: auto;
                  max-height: 150px;
                  width: auto;
                "
                :alt="placeName"
              />

              <div
                v-if="welcomeMessage"
                v-html="welcomeMessage"
                class="pt-5"
              ></div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col lg="6" md="6" sm="6">
          <b-card no-body class="bg-secondary border-0">
            <!-- <b-card-header class="bg-transparent pb-5" v-if="false" >
              <div class="text-muted text-center mt-2 mb-4">
                <small>Cadastrar via</small>
              </div>
              <div class="btn-wrapper text-center">
               <a class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="img/icons/common/facebook.svg"
                  /></span>
                  <span
                    @click.prevent="facebookRegister"
                    class="btn-inner--text"
                    >FaceBook</span
                  >
                </a>
                <a class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="img/icons/common/google.svg"
                  /></span>
                  <span @click.prevent="googleRegister" class="btn-inner--text"
                    >Google</span
                  >
                </a>
              </div>
            </b-card-header>  -->
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-muted mb-4">
                <h3>Cadastro de usuários</h3>
                <small
                  >selecione a cidade e instituição para afiliação e informe
                  seus dados para cadastro</small
                >
              </div>

              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  @submit.prevent="handleSubmit(normalRegister)"
                >
                  <!-- <span class="mr-3">Tipo de conta:</span>
                  <select class="form-select mb-3"
                    aria-label="Default select example"
                    v-model="form.conta">
                    <option disabled selected>Tipo de conta</option>
                    <option value="fisica">Física</option>
                    <option value="juridica">Jurídica</option>
                  </select> -->

                  <div class="form-group">
                    <div
                      class="btn-group btn-group-toggle btn-group-colors event-tag"
                    >
                      <b-form-radio-group
                        v-model="form.category"
                        :options="enabledcategories"
                        text-field="label"
                        value-field="key"
                        plain
                      >
                      </b-form-radio-group>
                    </div>
                  </div>

                  <b-row v-if="false">
                    <b-col cols="12">
                      <b-form-radio-group
                        v-model="form.pessoa_empresa"
                        :options="optionsPessoaEmpresa"
                        text-field="label"
                        value-field="key"
                        plain
                      >
                      </b-form-radio-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <b-form-select
                        v-if="!$route.query.pid"
                        v-model="form.pidCity"
                        class="mb-3"
                      >
                        <template #first>
                          <b-form-select-option value="" disabled
                            >Selecione a cidade</b-form-select-option
                          >
                        </template>

                        <b-form-select-option
                          v-for="(city, idx) in bahiaCities"
                          :value="city[0]"
                          :key="idx"
                        >
                          {{ city[1] }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <b-form-select
                        v-if="!$route.query.pid"
                        v-model="form.pid"
                        class="mb-3"
                      >
                        <template #first>
                          <b-form-select-option :value="undefined" disabled
                            >Selecione a instituição</b-form-select-option
                          >
                        </template>

                        <b-form-select-option
                          v-for="(place, idx) in places"
                          :value="place[0]"
                          :key="idx"
                        >
                          {{ place[1] }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-col>
                    <!-- <b-col cols="12" class="pt-0 mb-4 mt--3">
                      <div class="text-right small">
                        não encontrou? <a @click="openModalRequestInstitution" style="cursor: pointer; color: #5e72e4;">solicitar cadastro</a>
                      </div>
                      <small>
                      </small>
                    </b-col> -->
                  </b-row>
                  <!--
                  <b-row align-h="end" class="pt-0 mb-2 mt--4" xstyle="margin-top: 0%; margin-bottom: 7%;">
                  </b-row> -->
                  <div v-if="form.pid">
                    <validation-observer
                      ref="observerSocialLogin"
                      rules="required"
                    >
                      <base-input
                        v-model="form.name"
                        :placeholder="
                          form.pessoa_empresa == 'pessoa'
                            ? 'Nome'
                            : 'Razão Social'
                        "
                        alternative
                        class="mb-3"
                        prepend-icon="ni ni-single-02"
                        name="Name"
                        :rules="{ required: true }"
                      >
                      </base-input>

                      <base-input
                        v-model="form.cpf_cnpj"
                        v-mask="
                          form.pessoa_empresa == 'pessoa'
                            ? ['###.###.###-##']
                            : ['##.###.###/####-##']
                        "
                        :placeholder="
                          form.pessoa_empresa == 'pessoa' ? 'CPF' : 'CNPJ'
                        "
                        alternative
                        class="mb-3"
                        prepend-icon="ni ni-lock-circle-open"
                        type="text"
                        name="CPF"
                      >
                      </base-input>
                    </validation-observer>

                    <base-input
                      v-model="form.email"
                      :rules="{ required: true, email: true }"
                      @keyup="emailOnChange"
                      alternative
                      class="mb-3"
                      prepend-icon="ni ni-email-83"
                      placeholder="Email"
                      name="Email"
                    >
                    </base-input>

                    <b-row>
                      <b-col cols="5">
                        <b-form-select v-model="phoneFlag" class="mb-3">
                          <template #first>
                            <b-form-select-option value="" disabled
                              >Selecione o país</b-form-select-option
                            >
                          </template>

                          <b-form-select-option
                            v-for="(flag, idx) in dialCodesArray"
                            :value="flag.iso"
                            :key="idx"
                          >
                            {{
                              getFlagEmoji(flag.iso) +
                              ' ' +
                              flag.name +
                              ' +' +
                              flag.dialcode
                            }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-col>

                      <b-col cols="7">
                        <base-input
                          v-model="form.phone"
                          v-mask="phoneMask()"
                          alternative
                          class="mb-3"
                          prepend-icon="fas fa-phone"
                          placeholder="Telefone"
                          name="Telefone"
                        >
                        </base-input>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="10">
                        <base-input
                          v-model="form.password"
                          :rules="{ required: true, min: 6 }"
                          alternative
                          class="mb-3"
                          placeholder="Senha"
                          :type="!passwordVisible ? 'password' : 'text'"
                          name="Senha"
                          prepend-icon="ni ni-lock-circle-open"
                        >
                        </base-input>
                      </b-col>

                      <b-col cols="2" style="margin-top: 3.5%">
                        <b-icon
                          @click="seePassword()"
                          :icon="!passwordVisible ? 'eye-fill' : 'eye-slash'"
                          aria-hidden="true"
                        ></b-icon>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="10">
                        <base-input
                          v-model="form.confirmaPassword"
                          :rules="{ required: true, min: 6 }"
                          alternative
                          class="mb-3"
                          prepend-icon="ni ni-lock-circle-open"
                          placeholder="Confirme a Senha"
                          :type="!confirmPasswordVisible ? 'password' : 'text'"
                          name="confirmarSenha"
                        >
                        </base-input>
                      </b-col>

                      <b-col cols="2" style="margin-top: 3.5%">
                        <b-icon
                          @click="seeConfirmPassword()"
                          :icon="
                            !confirmPasswordVisible ? 'eye-fill' : 'eye-slash'
                          "
                          aria-hidden="true"
                        ></b-icon>
                      </b-col>
                    </b-row>
                  </div>

                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4"
                      >Cadastrar</b-button
                    >
                    <!-- <router-link v-if="false" :to="{ path: '/login' }">
                      <base-button class="btn btn-md btn-default mt-4" type="button">Entrar</base-button>
                    </router-link> -->
                  </div>

                  <small>
                    <div class="text-right mt-4">
                      já é cadastrado?
                      <router-link
                        :to="{
                          path: `/login${
                            form.pid != undefined ? '?pid=' + form.pid : ''
                          }`,
                        }"
                        >Fazer login</router-link
                      >
                    </div>
                  </small>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-modal
        :model.sync="showModalRequestInstitution"
        noCloseOnBackdrop
        noCloseOnEsc
        :size="'sm'"
      >
        <template #header>
          <h2 align-v="start" class="card-header w-100">
            Cadastrar Instituição
          </h2>
        </template>

        <div>
          <validation-observer ref="observerInstitution" rules="required">
            <b-row align-h="center">
              <b-col cols="12">
                <base-input
                  v-model="institutionForm.name"
                  placeholder="Nome da Instituição"
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-single-02"
                  name="Name"
                  :rules="{ required: true }"
                >
                </base-input>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col cols="12">
                <base-input
                  v-model="institutionForm.cnpj"
                  v-mask="['##.###.###/####-##']"
                  placeholder="CNPJ"
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  type="text"
                  name="CNPJ"
                >
                </base-input>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col cols="12">
                <base-input
                  v-model="institutionForm.email"
                  placeholder="Email da Instituição"
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-email-83"
                  type="email"
                  name="Email"
                >
                </base-input>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col cols="12">
                <base-input
                  v-model="institutionForm.phone"
                  v-mask="['(##) #####-####']"
                  placeholder="Telefone da Instituição"
                  alternative
                  class="mb-3"
                  prepend-icon="fas fa-phone"
                  type="text"
                  name="Telefone"
                >
                </base-input>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col cols="12">
                <b-form-select v-model="institutionForm.state" class="mb-3">
                  <template #first>
                    <b-form-select-option :value="undefined" disabled
                      >Selecione o estado</b-form-select-option
                    >
                  </template>

                  <b-form-select-option
                    v-for="(place, idx) in states"
                    :value="place"
                    :key="idx"
                  >
                    {{ place[2] }}
                  </b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col cols="12">
                <b-form-select v-model="institutionForm.city" class="mb-3">
                  <template #first>
                    <b-form-select-option :value="undefined" disabled
                      >Selecione a cidade</b-form-select-option
                    >
                  </template>

                  <b-form-select-option
                    v-for="(place, idx) in cities"
                    :value="place"
                    :key="idx"
                  >
                    {{ place[1] }}
                  </b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
          </validation-observer>
        </div>

        <template #footer>
          <div>
            <b-row align-h="end">
              <b-col>
                <base-button
                  @click="requestInstitution()"
                  :disabled="sendingMessage"
                  size="sm"
                  type="primary"
                  icon
                  >Cadastrar</base-button
                >
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import Modal from '@/components/Modal'
import bocapioNodeService from '../../services/nodejs/index'
import { publicLogoSource, readPublicXField, placeFromPublicData } from '@/store/utils/placePublicData'
import bocapioCakeService from '../../services/cakephp/index'
import { mapActions } from 'vuex'
import { VueMaskDirective } from 'v-mask'

export default {
  name: 'userRegister',

  directives: { mask: VueMaskDirective },

  components: {
    // Modal
  },

  data() {
    return {
      form: {
        name: '',
        email: '',
        category: 1,
        phone: '',
        cpf_cnpj: '',
        password: '',
        confirmaPassword: '',
        pid: '',
        pidCity: '',
        pessoa_empresa: 'pessoa',
      },
      institutionForm: {
        name: '',
        cnpj: '',
        email: '',
        phone: '',
        city: undefined,
        state: undefined,
      },
      categories: [
        { key: 1, label: 'Guias e Condutores', enabled: true },
        { key: 2, label: 'Fornecedor', enabled: false },
        { key: 3, label: 'Associado', enabled: false },
        { key: 4, label: 'Moradores', enabled: false },
      ],
      user: {},
      inputTest: '',
      place_public_data: false,
      placeLogoUrl: null,
      placeLogoObjectUrl: null,
      phoneFlag: 'BR',
      dialCodesArray: [],
      states: [],
      bahiaCities: [],
      cities: [],
      places: [],
      passwordVisible: false,
      confirmPasswordVisible: false,
      showModalRequestInstitution: false,
      sendingMessage: false,
      optionsPessoaEmpresa: [
        { label: 'Pessoa', key: 'pessoa' },
        { label: 'Empresa', key: 'empresa' },
      ],
    }
  },

  watch: {
    ['form.pidCity'](newValue, oldValue) {
      if (newValue != undefined && newValue != '') {
        this.loadPlaces()
      }
    },

    ['form.pid'](newValue, oldValue) {
      if (newValue != undefined && newValue != '') {
        // Parque da Muritiba: habilita categoria Moradores
        const muritibaUuid = '5662C894-ABAE-11EC-8BF6-F23C9227EC8D'
        const moradores = this.categories.find((c) => c.key === 4)
        if (newValue == muritibaUuid) {
          if (moradores) moradores.enabled = true
        } else {
          this.form.category = 1
          if (moradores) moradores.enabled = false
        }
        this.loadPublicData()
      }
    },

    ['institutionForm.state'](newValue, oldValue) {
      if (newValue != undefined && newValue != '' && newValue.length > 0) {
        this.institutionForm.city = undefined
        this.loadCities()
      }
    },

    places(newValue, oldValue) {
      if (
        (newValue == undefined || newValue.length == 0) &&
        oldValue.length > 0
      ) {
        this.form.pid = undefined
      }
    },
  },

  methods: {
    ...mapActions('auth', ['loginRequest', 'logoutRequest']),

    onChange(event) {
      // console.log("value", event.target.value);
    },

    loadDialCodes() {
      bocapioCakeService.getCountriesDialcode().then((resp) => {
        this.dialCodesArray = Object.values(JSON.parse(resp.countries))
      })
    },

    loadStates() {
      bocapioCakeService.getUF(1).then((resp) => {
        this.states = JSON.parse(resp.states)
      })
    },

    loadCities() {
      bocapioCakeService
        .getCities(this.institutionForm.state[0])
        .then((resp) => {
          this.cities = JSON.parse(resp.cities)
          this.cities = Object.entries(this.cities)
        })
    },

    loadBahiaCities() {
      bocapioCakeService.getCities(5).then((resp) => {
        this.bahiaCities = JSON.parse(resp.cities)
        this.bahiaCities = Object.entries(this.bahiaCities).splice(0, 13)
      })
    },

    loadPlaces() {
      bocapioCakeService
        .getPlacesList(`${this.form.pidCity},uuid`)
        .then((resp) => {
          this.places = resp.list
          this.places = Object.entries(this.places)
        })
    },

    clearPlaceLogo() {
      if (this.placeLogoObjectUrl) {
        URL.revokeObjectURL(this.placeLogoObjectUrl)
        this.placeLogoObjectUrl = null
      }
    },

    async loadPlaceLogo() {
      this.clearPlaceLogo()
      this.placeLogoUrl = null
      const resolved = publicLogoSource(this.place_public_data)
      if (!resolved || !resolved.src) return
      if (resolved.type === 'url') {
        this.placeLogoUrl = resolved.src
        return
      }
      try {
        const response = await bocapioNodeService.getFileByPath(resolved.src)
        const objectUrl = URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        )
        this.placeLogoObjectUrl = objectUrl
        this.placeLogoUrl = objectUrl
      } catch (error) {
        console.warn('Não foi possível carregar o logotipo do gestor:', error)
      }
    },

    loadPublicData() {
      const PID =
        this.form.pid == undefined || this.form.pid == null
          ? null
          : this.form.pid

      if (!PID) return
      bocapioNodeService.getPlacePublicData(PID).then((response) => {
        this.place_public_data = response.data
        this.loadPlaceLogo()
        sessionStorage.setItem('place_public_data', JSON.stringify(response.data))
      })
    },

    getFlagEmoji(countryCode) {
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt())
      return String.fromCodePoint(...codePoints)
    },

    phoneMask() {
      var cod_country = ''

      if (
        this.dialCodesArray.length > 0 &&
        this.phoneFlag != undefined &&
        this.phoneFlag != null &&
        this.phoneFlag != ''
      ) {
        cod_country = this.dialCodesArray.find(
          (i) => i.iso == this.phoneFlag
        ).dialcode
        cod_country = '+' + cod_country
        return `${cod_country} (##) #####-####`
      }

      return '(##) #####-####'
    },

    emailOnChange() {
      this.form.email = this.form.email.toLowerCase().replace(/\s/g, '')
    },

    seePassword() {
      this.passwordVisible = !this.passwordVisible
    },
    seeConfirmPassword() {
      this.confirmPasswordVisible = !this.confirmPasswordVisible
    },

    resetInstitutionForm() {
      this.institutionForm = {
        name: '',
        cnpj: '',
        email: '',
        phone: '',
        city: undefined,
        state: undefined,
      }
    },

    openModalRequestInstitution() {
      this.resetInstitutionForm()
      this.showModalRequestInstitution = true
    },

    async requestInstitution() {
      const isValid = await this.$refs.observerInstitution

      if (isValid) {
        this.sendingMessage = true
        this.showModalRequestInstitution = false
      }
    },

    normalRegister() {
      if (this.form.password === this.form.confirmaPassword) {
        this.user = {
          username: this.form.email,
          password: this.form.password,
        }

        bocapioNodeService
          .registerV2(this.form)
          .then((response) => {
            // localStorage.setItem(TokenKey, this.user)

            sessionStorage.setItem('username', this.form.email)
            sessionStorage.setItem('password', this.form.password)
            this.$router.push({
              path: `/login${
                this.form.pid != undefined ? '?pid=' + this.form.pid : ''
              }`,
            })
          })
          .catch((error) => {
            console.log('error', error)
            swal.fire({
              title: error.data.status == 'errro' ? 'Erro' : 'Atenção',
              text: error.data.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-warning',
              // icon: "warning",
            })
          })
      } else {
        swal.fire({
          title: `Dados incorretos`,
          text: 'Confirmar senha informada, não corresponde com a senha...',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-default',
          icon: 'error',
        })
      }
    },

    facebookRegister() {
      window.FB.login((response) => {
        console.log('fb response', response)
      }, this.params)
    },

    async googleRegister() {
      const isValid = await this.$refs.observerSocialLogin
      console.log('isValid', isValid)
      if (isValid) {
        this.$gAuth
          .signIn()
          .then((GoogleUser) => {
            // on success do something
            console.log('GoogleUser', GoogleUser)

            var userInfo = {
              loginType: 'google',
              google: GoogleUser,
            }

            this.loginRequest(userInfo)
            router.push('/home')
            //this.$router.push({ path: '/login'})
          })
          .catch((error) => {
            console.log('error', error)
          })
      }
    },
  },

  computed: {
    enabledcategories() {
      return this.categories.filter((c) => c.enabled)
    },
    placeName() {
      const place = placeFromPublicData(this.place_public_data)
      return (place && place.name) || ''
    },
    welcomeMessage() {
      return readPublicXField(this.place_public_data, 'welcome_msg')
    },
  },

  created() {
    if (process.env.NODE_ENV != 'production') {
      window.jdebug = this
    }
    this.form.pid = this.$route.query.pid
    if (this.form.pid) {
      this.loadPublicData()
      this.loadPlaces()
    }
    this.loadDialCodes()
    this.loadStates()
    this.loadBahiaCities(5)
  },

  mounted() {},
}
</script>
